import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import MenuAdmin from "../navAdmin/Menu";
import { CurrentUserContext } from "../../../App";
import Content from "../../public/content/Content";
import ContentDetail from "../../public/content/ContentDetail";
import { useParams } from "react-router";

export default function AnnouncementAdmin() {
  const { setIsMessage } = useContext(CurrentUserContext);
  let params = useParams();
  const [role] = useState(JSON.parse(localStorage.getItem("user")));
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!role.auth.role.includes("ADMIN")) {
      setIsMessage({ type: "warning", data: "ปฏิเสธเข้าถึงข่าวประชาสัมพันธ์" });
      navigate("/admin");
    }
  }, []);

  return (
    <>
      <MenuAdmin menuActive={"news"} />
      <Content slug={"news"} role={"admin"} />
      {/* <ContentDetail /> */}
    </>
  );
}
